import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../store/Store";
import SummaryStatCards from "../../components/Stats/SummaryStatCards";
import PageTitle from "../../components/Page Component/PageTitle";
import SkillsView from "./SkillsView";
import SkillSectionManagement from "./SkillSectionManagement";
import DesignationSectionAssignment from "./DesignationSectionAssignment";
// import SkillDocument from "./SkillDocument";
// import UploadedDocuments from "./UploadedDocuments";

const SkillsSetup = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  const selectedRoleFromStore = useSelector((state: RootState) => state.auth.selectedRole);
  const selectedRole = selectedRoleFromStore || localStorage.getItem("selectedRole") || "";
  const isHR = selectedRole.toLowerCase() === "hr";

  useEffect(() => {
    if (!isHR) {
      navigate("/all-skills/reports", { replace: true });
    }
  }, [isHR, navigate]);

  if (!isHR) {
    return null;
  }

  return (
    <Box sx={{ width: "100%",  mt: 10, mb: 10 }}>
      <Box sx={{ mb: 3, px: 2 }}>
        <PageTitle>Skills Setup</PageTitle>
        <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
          Create skills, organize sections, and assign them to roles
        </Typography>
      </Box>
      <SummaryStatCards
        centered
        items={[
          {
            label: "Add Skills",
            value: "Create and manage skills",
            color: "primary.main",
            onClick: () => setValue(0),
            active: value === 0,
          },
          {
            label: "Skill Sections",
            value: "Group skills by category",
            color: "success.main",
            onClick: () => setValue(1),
            active: value === 1,
          },
          {
            label: "Roles Sections",
            value: "Assign sections to roles",
            color: "info.main",
            onClick: () => setValue(2),
            active: value === 2,
          },
        ]}
      />
      <Box sx={{ width: "100%" }}>
        {value === 0 && <SkillsView />}
        {value === 1 && <SkillSectionManagement />}
        {value === 2 && <DesignationSectionAssignment />}
      </Box>
    </Box>
  );
};

export default SkillsSetup;
